import type { CSSProperties } from "react";
import { extendedColors, sysColors } from "@/assets/theme/colors";
import {
  COMPACT_GLOBAL_NAVBAR_ADD_ICON_SIZE_PX,
  COMPACT_GLOBAL_NAVBAR_ICON_SIZE_PX,
  COMPACT_GLOBAL_TOOLBAR_CONTROL_HEIGHT_PX
} from "@/components/TopActionBar/compactNavbarChrome";

const silverFill = extendedColors["extended-pgasilver-brand-color"];
const iconInk = sysColors["sys-brand-on-surface"];

export const GLOBAL_TOOLBAR_CONTROL_BORDER_RADIUS_PX = 4;

export const globalToolbarIconButtonWrapClassName = "inline-flex rounded-[4px]";

export const globalAddButtonFilledStyle = {
  gap: 0,
  backgroundColor: silverFill,
  "--md-outlined-button-with-leading-icon-leading-space": "8px",
  "--md-outlined-button-with-leading-icon-trailing-space": "8px",
  "--md-sys-color-primary": iconInk,
  "--md-sys-color-outline": silverFill,
  "--md-outlined-button-outline-color": silverFill,
  "--md-outlined-button-outline-width": "0px",
  "--md-outlined-button-pressed-outline-color": silverFill,
  "--md-outlined-button-icon-size": "24px",
  "--md-outlined-button-icon-color": iconInk,
  "--md-outlined-button-hover-icon-color": iconInk,
  "--md-outlined-button-focus-icon-color": iconInk,
  "--md-outlined-button-pressed-icon-color": iconInk,
  "--md-outlined-button-hover-state-layer-color": sysColors["sys-brand-on-surface"],
  "--md-outlined-button-hover-state-layer-opacity": "0.08",
  "--md-outlined-button-pressed-state-layer-opacity": "0.12",
  "--md-focus-ring-color": sysColors["sys-brand-primary"],
  "--md-outlined-button-focus-outline-color": sysColors["sys-brand-primary"],
  "--md-outlined-button-container-shape": `${GLOBAL_TOOLBAR_CONTROL_BORDER_RADIUS_PX}px`
} as CSSProperties;

function createCompactGlobalToolbarBorderlessIconStyle(iconSizePx: number): CSSProperties {
  const hitAreaPx = COMPACT_GLOBAL_TOOLBAR_CONTROL_HEIGHT_PX;
  const insetPx = Math.round((hitAreaPx - iconSizePx) / 2);

  return {
    gap: 0,
    backgroundColor: "transparent",
    width: `${hitAreaPx}px`,
    height: `${hitAreaPx}px`,
    minWidth: `${hitAreaPx}px`,
    minHeight: `${hitAreaPx}px`,
    "--md-outlined-button-container-height": `${hitAreaPx}px`,
    "--md-outlined-button-with-leading-icon-leading-space": `${insetPx}px`,
    "--md-outlined-button-with-leading-icon-trailing-space": `${insetPx}px`,
    "--md-sys-color-primary": iconInk,
    "--md-sys-color-outline": "transparent",
    "--md-outlined-button-outline-color": "transparent",
    "--md-outlined-button-outline-width": "0px",
    "--md-outlined-button-pressed-outline-color": "transparent",
    "--md-outlined-button-icon-size": `${iconSizePx}px`,
    "--md-outlined-button-icon-color": iconInk,
    "--md-outlined-button-hover-icon-color": iconInk,
    "--md-outlined-button-focus-icon-color": iconInk,
    "--md-outlined-button-pressed-icon-color": iconInk,
    "--md-outlined-button-hover-state-layer-color": sysColors["sys-brand-on-surface"],
    "--md-outlined-button-hover-state-layer-opacity": "0.08",
    "--md-outlined-button-pressed-state-layer-opacity": "0.12",
    "--md-focus-ring-color": sysColors["sys-brand-primary"],
    "--md-outlined-button-focus-outline-color": "transparent",
    "--md-outlined-button-container-shape": `${GLOBAL_TOOLBAR_CONTROL_BORDER_RADIUS_PX}px`
  } as CSSProperties;
}

export const compactGlobalToolbarBorderlessIconStyle = createCompactGlobalToolbarBorderlessIconStyle(
  COMPACT_GLOBAL_NAVBAR_ICON_SIZE_PX
);

export const compactGlobalToolbarBorderlessAddIconStyle = createCompactGlobalToolbarBorderlessIconStyle(
  COMPACT_GLOBAL_NAVBAR_ADD_ICON_SIZE_PX
);
